import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const Sport = styled('div', { label: 'Sport' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;

interface EventsInPlayWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setWrapper = (variant: DefaultComponentVariantType | null = null, theme: EmotionTheme): SerializedStyles => {
  if (variant === DefaultComponentVariantType.TERTIARY) {
    return css`
        background-color: ${theme.star.unified.layoutGlobal.bgColor};
        height: 100%;
        display: flex;
        flex-flow: column;

        & .in-play-page-general {
            height: stretch;
            display: flex;
            flex-flow: column;
        }
    `
  }

  return css`
      background-color: ${theme.star.layoutGlobal.bgColor};
  `
}

export const EventsInPlayWrapper = withConfig(theme => styled('div', { label: 'EventsInPlayWrapper' })<EventsInPlayWrapperPropsType>`
    margin-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '8px': '0'};
    ${({ variant }) => setWrapper(variant, theme)};
`);

interface InPlayHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

export const InPlayHeader = withConfig(theme => styled('div', { label: 'InPlayHeader' })<InPlayHeaderPropsType>`
    display: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'flex': 'none'};
    height: 88px;
    padding: 16px;
    font-size: ${theme.star.fontSize.medium};
    font-weight: ${theme.star.fontWeight.bold};
    white-space: nowrap;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.big};
        padding: 24px;
    }
`);
